import React from 'react';
import { Link } from 'react-router-dom';
import { GiveawayWorkspace } from '../components/GiveawayWorkspace';

export default function AdminGiveaways() {
  return <div className="bg-cream-light min-h-screen py-8" data-testid="admin-giveaways-page"><div className="max-w-6xl mx-auto px-4 sm:px-6">
    <Link to="/admin/bloom" className="inline-block text-sm text-navy underline mb-6" data-testid="giveaway-back-bloom">← Instagram & Bloom admin</Link>
    <GiveawayWorkspace admin />
  </div></div>;
}